import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import icons from "../../icons.config";
import { signUpApi } from "../../Providers/authProvider"; // Import the API function

const SignupPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "mobile") {
      // Remove non-numeric characters and limit to 10 digits
      const sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, mobile: sanitizedValue });
    } else if (name === "email") {
      // Allow only valid email characters
      const sanitizedValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");
      setFormData({ ...formData, email: sanitizedValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
  
    const { firstName, lastName, email, mobile } = formData;
  
    if (!firstName || !lastName || !email || !mobile) {
      setError("All fields are required!");
      return;
    }
  
    if (!validateEmail(email)) {
      setError("Invalid email format!");
      return;
    }
  
    if (mobile.length !== 10) {
      setError("Phone number must be exactly 10 digits.");
      return;
    }
  
    setLoading(true);
  
    try {
      const data = await signUpApi({
        first_name: firstName,
        last_name: lastName,
        email_id: email,
        mobile_number: mobile,
      });
  
      if (data.success) {
        navigate("/getotp", { state: { mobile } });
      } else {
        setError(data.message || "Failed to send OTP.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <>
      <Navbar />
      <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
        <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-[50%] lg:w-[70%]" />
        </div>
        <div className="hidden lg:block absolute left-8 top-20 z-10">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
        </div>
        <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
          <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">SIGN UP</h2>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid gap-6 md:grid-cols-2">
              <div className="relative">
                <label htmlFor="firstName" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
                  FIRST NAME
                </label>
                <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="Enter your first name" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
              </div>

              <div className="relative">
                <label htmlFor="lastName" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
                  LAST NAME
                </label>
                <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Enter your last name" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
              </div>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div className="relative">
                <label htmlFor="email" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
                  E-MAIL ADDRESS
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
              </div>

              <div className="relative">
                <label htmlFor="mobile" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
                  PHONE
                </label>
                <input type="tel" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="Enter your mobile number" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <input type="checkbox" id="privacyPolicy" name="privacyPolicy" className="w-4 h-4 text-primary1 rounded focus:ring-primary1" required />
              <label htmlFor="privacyPolicy" className="text-xs font-outfit text-primary1">
                I agree to the <a href="#" className="text-hcolor underline">Privacy Policy</a> and <a href="#" className="text-hcolor underline">Terms of Service</a>.
              </label>
            </div>

            {error && <p className="text-red-500 text-xs">{error}</p>}

            <div className="lg:px-52">
              <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-md font-outfit font-light hover:bg-tertiary hover:text-hcolor hover:border-2 focus:outline-none focus:ring-2 focus:ring-primary1 my-1" disabled={loading}>
                {loading ? "Sending OTP..." : "SUBMIT"}
              </button>
            </div>

            <div className="text-center space-y-6">
              <p className="text-sm text-hcolor font-outfit font-light">
                Already have an account? <a href="/login" className="text-primary1 underline">Log in</a>
              </p>
              <p className="text-sm text-hcolor font-outfit font-light">
                Having trouble Signing Up? <a href="/contact" className="text-primary1 underline">Get Help</a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <FooterDoodles />
      <Footer />
    </>
  );
};

export default SignupPage;
























// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Navbar from "../Navbar/navbar";
// import Footer from "../Footer/footer";
// import FooterDoodles from "../Footer/footerDoodles";
// import icons from "../../icons.config";
// import { signUpApi } from "../../Providers/authProvider"; // Import the API function

// const SignupPage = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     mobile: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     const { name, value } = e.target;
  
//     if (name === "mobile") {
//       // Remove non-numeric characters and limit to 10 digits
//       const sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
//       setFormData({ ...formData, mobile: sanitizedValue });
//     } else if (name === "email") {
//       // Allow only valid email characters
//       const sanitizedValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");
//       setFormData({ ...formData, email: sanitizedValue });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };
  
//   const validateEmail = (email) => {
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     return emailRegex.test(email);
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
  
//     const { firstName, lastName, email, mobile } = formData;
  
//     if (!firstName || !lastName || !email || !mobile) {
//       setError("All fields are required!");
//       return;
//     }
  
//     if (!validateEmail(email)) {
//       setError("Invalid email format!");
//       return;
//     }
  
//     if (mobile.length !== 10) {
//       setError("Phone number must be exactly 10 digits.");
//       return;
//     }
  
//     setLoading(true);
  
//     try {
//       const data = await signUpApi({
//         first_name: firstName,
//         last_name: lastName,
//         email_id: email,
//         mobile_number: mobile,
//       });
  
//       if (data.success) {
//         navigate("/getotp", { state: { mobile } });
//       } else {
//         setError(data.message || "Failed to send OTP.");
//       }
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   return (
//     <>
//       <Navbar />
//       <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
//         <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
//           <img src={icons.trendCircles} alt="Doodle Left" className="w-[50%] lg:w-[70%]" />
//         </div>
//         <div className="hidden lg:block absolute left-8 top-20 z-10">
//           <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
//         </div>
//         <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
//           <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">SIGN UP</h2>

//           <form className="space-y-6" onSubmit={handleSubmit}>
//             <div className="grid gap-6 md:grid-cols-2">
//               <div className="relative">
//                 <label htmlFor="firstName" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
//                   FIRST NAME
//                 </label>
//                 <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="Enter your first name" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
//               </div>

//               <div className="relative">
//                 <label htmlFor="lastName" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
//                   LAST NAME
//                 </label>
//                 <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Enter your last name" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
//               </div>
//             </div>

//             <div className="grid gap-6 md:grid-cols-2">
//               <div className="relative">
//                 <label htmlFor="email" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
//                   E-MAIL ADDRESS
//                 </label>
//                 <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
//               </div>

//               <div className="relative">
//                 <label htmlFor="mobile" className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-md font-medium -translate-y-4 scale-75 top-1 z-10">
//                   PHONE
//                 </label>
//                 <input type="tel" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="Enter your mobile number" className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1 placeholder:text-secondary" />
//               </div>
//             </div>

//             <div className="flex items-center space-x-3">
//               <input type="checkbox" id="privacyPolicy" name="privacyPolicy" className="w-4 h-4 text-primary1 rounded focus:ring-primary1" required />
//               <label htmlFor="privacyPolicy" className="text-xs font-outfit text-primary1">
//                 I agree to the <a href="#" className="text-hcolor underline">Privacy Policy</a> and <a href="#" className="text-hcolor underline">Terms of Service</a>.
//               </label>
//             </div>

//             {error && <p className="text-red-500 text-xs">{error}</p>}

//             <div className="lg:px-52">
//               <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-md font-outfit font-light hover:bg-tertiary hover:text-hcolor hover:border-2 focus:outline-none focus:ring-2 focus:ring-primary1 my-1" disabled={loading}>
//                 {loading ? "Sending OTP..." : "SUBMIT"}
//               </button>
//             </div>

//             <div className="text-center space-y-6">
//               <p className="text-sm text-hcolor font-outfit font-light">
//                 Already have an account? <a href="/login" className="text-primary1 underline">Log in</a>
//               </p>
//               <p className="text-sm text-hcolor font-outfit font-light">
//                 Having trouble Signing Up? <a href="/help" className="text-primary1 underline">Get Help</a>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//       <FooterDoodles />
//       <Footer />
//     </>
//   );
// };

// export default SignupPage;





